// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__epKb4","footer":"ModalFilter_footer__2R1km"};